/**
 * Elenco completo dei prefissi telefonici internazionali.
 * - name: nome del paese in italiano (usato anche per la ricerca)
 * - dialCode: prefisso internazionale senza "+"
 * - iso: codice ISO 3166-1 alpha-2 in minuscolo (usato per la bandiera flag-icons: classe "fi fi-<iso>")
 *
 * L'Italia e' in testa (default). Il resto e' ordinato alfabeticamente per nome italiano.
 */
export type CountryPrefix = { name: string; dialCode: string; iso: string };

export const countryPrefixes: CountryPrefix[] = [
  { name: "Italia", dialCode: "39", iso: "it" },

  { name: "Afghanistan", dialCode: "93", iso: "af" },
  { name: "Albania", dialCode: "355", iso: "al" },
  { name: "Algeria", dialCode: "213", iso: "dz" },
  { name: "Andorra", dialCode: "376", iso: "ad" },
  { name: "Angola", dialCode: "244", iso: "ao" },
  { name: "Anguilla", dialCode: "1264", iso: "ai" },
  { name: "Antigua e Barbuda", dialCode: "1268", iso: "ag" },
  { name: "Arabia Saudita", dialCode: "966", iso: "sa" },
  { name: "Argentina", dialCode: "54", iso: "ar" },
  { name: "Armenia", dialCode: "374", iso: "am" },
  { name: "Aruba", dialCode: "297", iso: "aw" },
  { name: "Australia", dialCode: "61", iso: "au" },
  { name: "Austria", dialCode: "43", iso: "at" },
  { name: "Azerbaigian", dialCode: "994", iso: "az" },
  { name: "Bahamas", dialCode: "1242", iso: "bs" },
  { name: "Bahrein", dialCode: "973", iso: "bh" },
  { name: "Bangladesh", dialCode: "880", iso: "bd" },
  { name: "Barbados", dialCode: "1246", iso: "bb" },
  { name: "Belgio", dialCode: "32", iso: "be" },
  { name: "Belize", dialCode: "501", iso: "bz" },
  { name: "Benin", dialCode: "229", iso: "bj" },
  { name: "Bermuda", dialCode: "1441", iso: "bm" },
  { name: "Bhutan", dialCode: "975", iso: "bt" },
  { name: "Bielorussia", dialCode: "375", iso: "by" },
  { name: "Bolivia", dialCode: "591", iso: "bo" },
  { name: "Bosnia ed Erzegovina", dialCode: "387", iso: "ba" },
  { name: "Botswana", dialCode: "267", iso: "bw" },
  { name: "Brasile", dialCode: "55", iso: "br" },
  { name: "Brunei", dialCode: "673", iso: "bn" },
  { name: "Bulgaria", dialCode: "359", iso: "bg" },
  { name: "Burkina Faso", dialCode: "226", iso: "bf" },
  { name: "Burundi", dialCode: "257", iso: "bi" },
  { name: "Cambogia", dialCode: "855", iso: "kh" },
  { name: "Camerun", dialCode: "237", iso: "cm" },
  { name: "Canada", dialCode: "1", iso: "ca" },
  { name: "Capo Verde", dialCode: "238", iso: "cv" },
  { name: "Ciad", dialCode: "235", iso: "td" },
  { name: "Cile", dialCode: "56", iso: "cl" },
  { name: "Cina", dialCode: "86", iso: "cn" },
  { name: "Cipro", dialCode: "357", iso: "cy" },
  { name: "Citta del Vaticano", dialCode: "379", iso: "va" },
  { name: "Colombia", dialCode: "57", iso: "co" },
  { name: "Comore", dialCode: "269", iso: "km" },
  { name: "Congo (Rep. Dem.)", dialCode: "243", iso: "cd" },
  { name: "Congo (Rep.)", dialCode: "242", iso: "cg" },
  { name: "Corea del Nord", dialCode: "850", iso: "kp" },
  { name: "Corea del Sud", dialCode: "82", iso: "kr" },
  { name: "Costa Rica", dialCode: "506", iso: "cr" },
  { name: "Costa d'Avorio", dialCode: "225", iso: "ci" },
  { name: "Croazia", dialCode: "385", iso: "hr" },
  { name: "Cuba", dialCode: "53", iso: "cu" },
  { name: "Curacao", dialCode: "599", iso: "cw" },
  { name: "Danimarca", dialCode: "45", iso: "dk" },
  { name: "Dominica", dialCode: "1767", iso: "dm" },
  { name: "Ecuador", dialCode: "593", iso: "ec" },
  { name: "Egitto", dialCode: "20", iso: "eg" },
  { name: "El Salvador", dialCode: "503", iso: "sv" },
  { name: "Emirati Arabi Uniti", dialCode: "971", iso: "ae" },
  { name: "Eritrea", dialCode: "291", iso: "er" },
  { name: "Estonia", dialCode: "372", iso: "ee" },
  { name: "Eswatini", dialCode: "268", iso: "sz" },
  { name: "Etiopia", dialCode: "251", iso: "et" },
  { name: "Figi", dialCode: "679", iso: "fj" },
  { name: "Filippine", dialCode: "63", iso: "ph" },
  { name: "Finlandia", dialCode: "358", iso: "fi" },
  { name: "Francia", dialCode: "33", iso: "fr" },
  { name: "Gabon", dialCode: "241", iso: "ga" },
  { name: "Gambia", dialCode: "220", iso: "gm" },
  { name: "Georgia", dialCode: "995", iso: "ge" },
  { name: "Germania", dialCode: "49", iso: "de" },
  { name: "Ghana", dialCode: "233", iso: "gh" },
  { name: "Giamaica", dialCode: "1876", iso: "jm" },
  { name: "Giappone", dialCode: "81", iso: "jp" },
  { name: "Gibilterra", dialCode: "350", iso: "gi" },
  { name: "Gibuti", dialCode: "253", iso: "dj" },
  { name: "Giordania", dialCode: "962", iso: "jo" },
  { name: "Grecia", dialCode: "30", iso: "gr" },
  { name: "Grenada", dialCode: "1473", iso: "gd" },
  { name: "Groenlandia", dialCode: "299", iso: "gl" },
  { name: "Guadalupa", dialCode: "590", iso: "gp" },
  { name: "Guam", dialCode: "1671", iso: "gu" },
  { name: "Guatemala", dialCode: "502", iso: "gt" },
  { name: "Guinea", dialCode: "224", iso: "gn" },
  { name: "Guinea Equatoriale", dialCode: "240", iso: "gq" },
  { name: "Guinea-Bissau", dialCode: "245", iso: "gw" },
  { name: "Guyana", dialCode: "592", iso: "gy" },
  { name: "Haiti", dialCode: "509", iso: "ht" },
  { name: "Honduras", dialCode: "504", iso: "hn" },
  { name: "Hong Kong", dialCode: "852", iso: "hk" },
  { name: "India", dialCode: "91", iso: "in" },
  { name: "Indonesia", dialCode: "62", iso: "id" },
  { name: "Iran", dialCode: "98", iso: "ir" },
  { name: "Iraq", dialCode: "964", iso: "iq" },
  { name: "Irlanda", dialCode: "353", iso: "ie" },
  { name: "Islanda", dialCode: "354", iso: "is" },
  { name: "Isole Cayman", dialCode: "1345", iso: "ky" },
  { name: "Isole Faroe", dialCode: "298", iso: "fo" },
  { name: "Isole Marshall", dialCode: "692", iso: "mh" },
  { name: "Isole Salomone", dialCode: "677", iso: "sb" },
  { name: "Isole Vergini (UK)", dialCode: "1284", iso: "vg" },
  { name: "Isole Vergini (USA)", dialCode: "1340", iso: "vi" },
  { name: "Israele", dialCode: "972", iso: "il" },
  { name: "Kazakistan", dialCode: "7", iso: "kz" },
  { name: "Kenya", dialCode: "254", iso: "ke" },
  { name: "Kirghizistan", dialCode: "996", iso: "kg" },
  { name: "Kiribati", dialCode: "686", iso: "ki" },
  { name: "Kosovo", dialCode: "383", iso: "xk" },
  { name: "Kuwait", dialCode: "965", iso: "kw" },
  { name: "Laos", dialCode: "856", iso: "la" },
  { name: "Lesotho", dialCode: "266", iso: "ls" },
  { name: "Lettonia", dialCode: "371", iso: "lv" },
  { name: "Libano", dialCode: "961", iso: "lb" },
  { name: "Liberia", dialCode: "231", iso: "lr" },
  { name: "Libia", dialCode: "218", iso: "ly" },
  { name: "Liechtenstein", dialCode: "423", iso: "li" },
  { name: "Lituania", dialCode: "370", iso: "lt" },
  { name: "Lussemburgo", dialCode: "352", iso: "lu" },
  { name: "Macao", dialCode: "853", iso: "mo" },
  { name: "Macedonia del Nord", dialCode: "389", iso: "mk" },
  { name: "Madagascar", dialCode: "261", iso: "mg" },
  { name: "Malawi", dialCode: "265", iso: "mw" },
  { name: "Maldive", dialCode: "960", iso: "mv" },
  { name: "Malesia", dialCode: "60", iso: "my" },
  { name: "Mali", dialCode: "223", iso: "ml" },
  { name: "Malta", dialCode: "356", iso: "mt" },
  { name: "Marocco", dialCode: "212", iso: "ma" },
  { name: "Martinica", dialCode: "596", iso: "mq" },
  { name: "Mauritania", dialCode: "222", iso: "mr" },
  { name: "Mauritius", dialCode: "230", iso: "mu" },
  { name: "Messico", dialCode: "52", iso: "mx" },
  { name: "Micronesia", dialCode: "691", iso: "fm" },
  { name: "Moldavia", dialCode: "373", iso: "md" },
  { name: "Monaco", dialCode: "377", iso: "mc" },
  { name: "Mongolia", dialCode: "976", iso: "mn" },
  { name: "Montenegro", dialCode: "382", iso: "me" },
  { name: "Montserrat", dialCode: "1664", iso: "ms" },
  { name: "Mozambico", dialCode: "258", iso: "mz" },
  { name: "Myanmar", dialCode: "95", iso: "mm" },
  { name: "Namibia", dialCode: "264", iso: "na" },
  { name: "Nauru", dialCode: "674", iso: "nr" },
  { name: "Nepal", dialCode: "977", iso: "np" },
  { name: "Nicaragua", dialCode: "505", iso: "ni" },
  { name: "Niger", dialCode: "227", iso: "ne" },
  { name: "Nigeria", dialCode: "234", iso: "ng" },
  { name: "Norvegia", dialCode: "47", iso: "no" },
  { name: "Nuova Caledonia", dialCode: "687", iso: "nc" },
  { name: "Nuova Zelanda", dialCode: "64", iso: "nz" },
  { name: "Oman", dialCode: "968", iso: "om" },
  { name: "Paesi Bassi", dialCode: "31", iso: "nl" },
  { name: "Pakistan", dialCode: "92", iso: "pk" },
  { name: "Palau", dialCode: "680", iso: "pw" },
  { name: "Palestina", dialCode: "970", iso: "ps" },
  { name: "Panama", dialCode: "507", iso: "pa" },
  { name: "Papua Nuova Guinea", dialCode: "675", iso: "pg" },
  { name: "Paraguay", dialCode: "595", iso: "py" },
  { name: "Peru", dialCode: "51", iso: "pe" },
  { name: "Polinesia Francese", dialCode: "689", iso: "pf" },
  { name: "Polonia", dialCode: "48", iso: "pl" },
  { name: "Portogallo", dialCode: "351", iso: "pt" },
  { name: "Portorico", dialCode: "1787", iso: "pr" },
  { name: "Qatar", dialCode: "974", iso: "qa" },
  { name: "Regno Unito", dialCode: "44", iso: "gb" },
  { name: "Repubblica Ceca", dialCode: "420", iso: "cz" },
  { name: "Repubblica Centrafricana", dialCode: "236", iso: "cf" },
  { name: "Repubblica Dominicana", dialCode: "1809", iso: "do" },
  { name: "Reunion", dialCode: "262", iso: "re" },
  { name: "Romania", dialCode: "40", iso: "ro" },
  { name: "Ruanda", dialCode: "250", iso: "rw" },
  { name: "Russia", dialCode: "7", iso: "ru" },
  { name: "Sahara Occidentale", dialCode: "212", iso: "eh" },
  { name: "Saint Kitts e Nevis", dialCode: "1869", iso: "kn" },
  { name: "Saint Lucia", dialCode: "1758", iso: "lc" },
  { name: "Saint Vincent e Grenadine", dialCode: "1784", iso: "vc" },
  { name: "Samoa", dialCode: "685", iso: "ws" },
  { name: "San Marino", dialCode: "378", iso: "sm" },
  { name: "Sant'Elena", dialCode: "290", iso: "sh" },
  { name: "Sao Tome e Principe", dialCode: "239", iso: "st" },
  { name: "Senegal", dialCode: "221", iso: "sn" },
  { name: "Serbia", dialCode: "381", iso: "rs" },
  { name: "Seychelles", dialCode: "248", iso: "sc" },
  { name: "Sierra Leone", dialCode: "232", iso: "sl" },
  { name: "Singapore", dialCode: "65", iso: "sg" },
  { name: "Siria", dialCode: "963", iso: "sy" },
  { name: "Slovacchia", dialCode: "421", iso: "sk" },
  { name: "Slovenia", dialCode: "386", iso: "si" },
  { name: "Somalia", dialCode: "252", iso: "so" },
  { name: "Spagna", dialCode: "34", iso: "es" },
  { name: "Sri Lanka", dialCode: "94", iso: "lk" },
  { name: "Stati Uniti", dialCode: "1", iso: "us" },
  { name: "Sudafrica", dialCode: "27", iso: "za" },
  { name: "Sudan", dialCode: "249", iso: "sd" },
  { name: "Sudan del Sud", dialCode: "211", iso: "ss" },
  { name: "Suriname", dialCode: "597", iso: "sr" },
  { name: "Svezia", dialCode: "46", iso: "se" },
  { name: "Svizzera", dialCode: "41", iso: "ch" },
  { name: "Tagikistan", dialCode: "992", iso: "tj" },
  { name: "Taiwan", dialCode: "886", iso: "tw" },
  { name: "Tanzania", dialCode: "255", iso: "tz" },
  { name: "Thailandia", dialCode: "66", iso: "th" },
  { name: "Timor Est", dialCode: "670", iso: "tl" },
  { name: "Togo", dialCode: "228", iso: "tg" },
  { name: "Tonga", dialCode: "676", iso: "to" },
  { name: "Trinidad e Tobago", dialCode: "1868", iso: "tt" },
  { name: "Tunisia", dialCode: "216", iso: "tn" },
  { name: "Turchia", dialCode: "90", iso: "tr" },
  { name: "Turkmenistan", dialCode: "993", iso: "tm" },
  { name: "Ucraina", dialCode: "380", iso: "ua" },
  { name: "Uganda", dialCode: "256", iso: "ug" },
  { name: "Ungheria", dialCode: "36", iso: "hu" },
  { name: "Uruguay", dialCode: "598", iso: "uy" },
  { name: "Uzbekistan", dialCode: "998", iso: "uz" },
  { name: "Vanuatu", dialCode: "678", iso: "vu" },
  { name: "Venezuela", dialCode: "58", iso: "ve" },
  { name: "Vietnam", dialCode: "84", iso: "vn" },
  { name: "Yemen", dialCode: "967", iso: "ye" },
  { name: "Zambia", dialCode: "260", iso: "zm" },
  { name: "Zimbabwe", dialCode: "263", iso: "zw" },
];
